const { Axios } = require('./axios')

const getAdmins = async () => {
  const { data } = await Axios.get('/admins')
  return data
}

const getEmployees = async (payload) => {
  let search = payload.search ? '&search=' + payload.search : ''
  let country = payload.country ? '&country=' + payload.country : ''

  let filter =
    payload.statusFilter && payload.statusFilter != -1
      ? '&filter=' + payload.statusFilter
      : ''

  const { data } = await Axios.get(
    `mobile/employees?limit=${payload.limit}&page=${payload.page}${filter}${search}${country}`,
    {
      timeout: 0,
    }
  )

  return data?.data
}

const getEmployeeRegistrationLink = async () => {
  const { data } = await Axios.get(
    '/mobile/employees/get-pre-registration-link'
  )
  return data?.data
}

const changeInvitationLinkSatus = async (payload) => {
  const { data } = await Axios.post(
    '/mobile/employees/update-pre-invitation-link-status'
  )
  return data
}
const refreshInvitationLink = async () => {
  const { data } = await Axios.post(
    '/mobile/employees/refresh-pre-registration-link'
  )
  return data
}

const getEmployeeGroups = async (payload) => {
  let search = payload.search ? '&search=' + payload.search : ''
  let filter =
    payload.statusFilter && payload.statusFilter != -1
      ? '&filter=' + payload.statusFilter
      : ''
  const { data } = await Axios.get(
    `/mobile/employees/groups?limit=${payload.limit}&page=${payload.page}${filter}${search}`
  )

  return data?.data
}
const inviteSingleEmployee = async (payload) => {
  const { data } = await Axios.post('/mobile/employees/invite', payload, {
    timeout: 0,
  })
  return data
}

const createSingleEmployee = async (payload) => {
  const { data } = await Axios.post('/mobile/employees', payload, {
    timeout: 0,
  })
  return data
}

const inviteBulkEmployee = async (payload) => {
  const { data } = await Axios.post('mobile/employees/inivite/bulk', payload, {
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: 0,
  })
  return data
}

const createBulkEmployee = async (payload) => {
  const { data } = await Axios.post('mobile/employees/bulk', payload, {
    headers: {
      'Content-Type': `multipart/form-data'; boundary=${payload._boundary}`,
    },
    timeout: 6000000,
  })
  return data
}

const deleteSalary = async (payload) => {
  const { data } = await Axios.delete('mobile/salaries/' + payload)
  return data
}

const getEmployeeSalaries = async (payload) => {
  let search = payload.search ? '&search=' + payload.search : ''
  let filter =
    payload.statusFilter && payload.statusFilter != -1
      ? '&filter=' + payload.statusFilter
      : ''

  const { data } = await Axios.get(
    `mobile/salaries?limit=${payload.limit}&page=${payload.page}${filter}${search}`,
    {
      timeout: 0,
    }
  )

  return data?.data
}

const addSalary = async (payload) => {
  const { data } = await Axios.post('mobile/salaries', payload)
  return data
}

const netPayReverse = async (payload) => {
  const { data } = await Axios.post(
    '/mobile/salaries/net-pay-reverse',
    payload,
    {
      timeout: 0,
    }
  )
  return data
}

const grossPayReverse = async (payload) => {
  const { data } = await Axios.post(
    '/mobile/salaries/gross-pay-reverse',
    payload,
    {
      timeout: 0,
    }
  )
  return data
}

const getSalarySettings = async () => {
  const { data } = await Axios.get('/mobile/employees/salary-settings')
  return data?.data
}

const getEmployeeForSalary = async () => {
  const { data } = await Axios.get(`/mobile/employees/for-salary`, {
    timeout: 0,
  })

  return data?.data
}

const fullPayReverseBulk = async (payload) => {
  const { data } = await Axios.post('/mobile/salaries/bulk', payload, {
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: 0,
  })
  return data
}

const netPayReverseBulk = async (payload) => {
  const { data } = await Axios.post(
    'mobile/salaries/net-pay-reverse/bulk',
    payload,
    {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 0,
    }
  )
  return data
}

const grossPayReverseBulk = async (payload) => {
  const { data } = await Axios.post(
    'mobile/salaries/gross-pay-reverse/bulk',
    payload,
    {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 0,
    }
  )
  return data
}

const addBulkSalary = async (payload) => {
  const { data } = await Axios.post('mobile/salaries/multiple', payload, {
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: 0,
  })
  return data
}

//
const getEmployee = async (payload) => {
  const { data } = await Axios.get('/employees/' + payload)
  return data?.data
}

const addEmployeesToGroup = async (payload) => {
  const { data } = await Axios.post(
    '/mobile/employee-groups/add-employee',
    payload
  )
  return data
}

const editEmployeeGroup = async (payload) => {
  const { data } = await Axios.put(
    '/mobile/employee-groups/' + payload.id,
    payload.body
  )
  return data
}

const addEmployeeGroup = async (payload) => {
  const { data } = await Axios.post('mobile/employee-groups', payload)
  return data
}

const getEmployeeGroup = async (payload) => {
  const { data } = await Axios.get('/employee-groups/' + payload.id, payload)
  return data?.data
}
export const admin = {
  getAdmins,
  getEmployees,
  getEmployeeRegistrationLink,
  changeInvitationLinkSatus,
  refreshInvitationLink,
  getEmployeeGroups,
  inviteSingleEmployee,
  createSingleEmployee,
  inviteBulkEmployee,
  createBulkEmployee,
  deleteSalary,
  getEmployeeSalaries,
  addSalary,
  netPayReverse,
  grossPayReverse,
  getSalarySettings,
  getEmployeeForSalary,
  fullPayReverseBulk,
  netPayReverseBulk,
  grossPayReverseBulk,
  addBulkSalary,
  //
  getEmployee,
  addEmployeesToGroup,
  editEmployeeGroup,
  addEmployeeGroup,
  getEmployeeGroup,
}
